import { render } from "./CountdownPaywall.vue?vue&type=template&id=225acc38&scoped=true"
import script from "./CountdownPaywall.vue?vue&type=script&lang=js"
export * from "./CountdownPaywall.vue?vue&type=script&lang=js"

import "./CountdownPaywall.vue?vue&type=style&index=0&id=225acc38&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225acc38"],['__file',"src/views/paywall/CountdownPaywall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "225acc38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('225acc38', __exports__)) {
    console.log('reload')
    api.reload('225acc38', __exports__)
  }
  
  module.hot.accept("./CountdownPaywall.vue?vue&type=template&id=225acc38&scoped=true", () => {
    console.log('re-render')
    api.rerender('225acc38', render)
  })

}


export default __exports__